import { gql } from '@apollo/client';

export const GET_DELIVERY_TASKS = gql`
  query GetDeliveryTasks($filter: DeliveryTaskFilterInput, $pageRequest: DeliveryTaskPageRequestTypeInput) {
    getDeliveryTasks(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        routeHistoryId
        routeName
        originalDriverId
        driverAccountId
        pathPlanningTaskId
        driverTaskId
        areaId
        areaName
        warehouseId
        dspId
        taskDate
        status
        assignedParcels
        actualPickedUpParcels
        transferInParcels
        transferOutParcels
        estimatedDistanceKm
        estimatedDurationMinutes
        createdBy
        createdByName
        createdAt
        updatedAt
        isGroupRow
        totalTasks
        totalAssignedParcels
        totalActualPickedUp
        actualTotalParcels
        workIndex
        children {
          id
          routeHistoryId
          routeName
          originalDriverId
          driverAccountId
          pathPlanningTaskId
          driverTaskId
          areaId
          areaName
          warehouseId
          dspId
          taskDate
          status
          assignedParcels
          actualPickedUpParcels
          transferInParcels
          transferOutParcels
          estimatedDistanceKm
          estimatedDurationMinutes
          createdBy
          createdByName
          createdAt
          updatedAt
          actualTotalParcels
          workIndex
        }
        __typename
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
      __typename
    }
  }
`;